import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const fileLink = (url, name) =>
  url ? (
    <a href={url} target='_blank' rel='noreferrer'>
      {name || url}
    </a>
  ) : (
    '—'
  );

export const getExtraSaleViewSections = (
  t,
  item,
  { shoppingCenters, companyCategories } = {},
) => {
  if (!item?.id) {
    return [];
  }

  const shoppingCenterTitle =
    item.shopping_center ||
    item.shopping_center_title ||
    shoppingCenters?.find(
      (i) => String(i.value) === String(item.shopping_center_id),
    )?.title;

  const companyCategoryTitles =
    item.allData?.company_categories?.map((c) => c.title).join(', ') ||
    (item.company_category_ids || [])
      .map(
        (id) =>
          companyCategories?.find((c) => String(c.value) === String(id))?.title,
      )
      .filter(Boolean)
      .join(', ');

  const extrasaleHours = item.allData?.extrasale_hours || [];
  const timeSlotsValue =
    extrasaleHours.length > 0 ? (
      <>
        {extrasaleHours.map((hour, index) => (
          <React.Fragment key={hour.id || index}>
            {index > 0 && <br />}
            {display(hour.date_title)}
          </React.Fragment>
        ))}
      </>
    ) : (
      '—'
    );

  return [
    {
      title: t('Info'),
      fields: [
        { text: t('Titolo'), value: display(item.title) },
        {
          text: t('Numero insegne'),
          value: display(item.members_quantity),
        },
      ],
    },
    {
      title: t('Date'),
      fields: [
        { text: t('Data dal'), value: displayDate(item.date_from) },
        { text: t('Data al'), value: displayDate(item.date_to) },
        {
          text: t('Data scadenza adesione'),
          value: displayDate(item.membership_expiration_date),
        },
      ],
    },
    {
      title: t('Shop'),
      fields: [
        {
          text: t('Shopping center'),
          value: display(shoppingCenterTitle),
        },
        {
          text: t('CATEGORIE'),
          value: display(companyCategoryTitles),
        },
      ],
    },
    {
      title: t('Files'),
      fields: [
        { text: t('Location'), value: display(item.location) },
        {
          text: t('File'),
          value: fileLink(item.file, item.file_name),
        },
      ],
    },
    {
      title: t('Descrizione'),
      fields: [
        {
          text: t('Descrizione Attività'),
          value: display(item.description),
        },
      ],
    },
    {
      title: t('FASCE ORARIE'),
      fields: [{ text: t('Fasce orarie'), value: timeSlotsValue }],
    },
    {
      title: t('CANALI DI COMUNICAZIONE'),
      fields: [
        {
          text: 'Uso Archivio (printers)',
          value: displayBool(item.is_archive, t),
        },
        {
          text: 'NEWSLETTER (newsletter)',
          value: displayBool(item.is_newsletter, t),
        },
        { text: 'RADIO VILLAGE (radio)', value: displayBool(item.is_radio, t) },
        { text: 'SOCIAL (social)', value: displayBool(item.is_social, t) },
        { text: 'WEB', value: displayBool(item.is_web, t) },
      ],
    },
  ];
};
